import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import LiveCommandCenter from './LiveCommandCenter';
import SetupWizard from './SetupWizard';
import UserManagement from './UserManagement';
import Analytics from './Analytics';
import Candidates from './Candidates';
import Profile from './Profile';
import HardwareGrid from './HardwareGrid';
import DevTools from './DevTools';
import { SimulationProvider } from '../../contexts/SimulationContext';
import './AdminDashboard.css';

const AdminDashboard = ({ onLogout }) => {
  const [activeTab, setActiveTab] = useState('live');

  const renderContent = () => {
    switch (activeTab) {
      case 'live':
        return <LiveCommandCenter />;
      case 'setup':
        return <SetupWizard onLaunchSuccess={() => setActiveTab('live')} />;
      case 'users':
        return <UserManagement />;
      case 'analytics':
        return <Analytics />;
      case 'candidates':
        return <Candidates />;
      case 'profile':
        return (
            <div className="main-view">
                <Profile user={user} />
            </div>
        );
      case 'devices':
        return <HardwareGrid />;
      default:
        return <LiveCommandCenter />;
    }
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <SimulationProvider>
      <div className="dashboard-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={onLogout} />
        
        <div className="content-area">
          <Navbar activeTab={activeTab} onProfileClick={() => setActiveTab('profile')} />
          {renderContent()}
        </div>

        {/* Global Simulation Engine Drawer */}
        <DevTools />
      </div>
    </SimulationProvider>
  );
};

export default AdminDashboard;
